import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { Globe } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");
    setSubmitting(true);
    try {
      const res = await api.post("/auth/forgot-password", { email });
      setMessage(res.data.message);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
      <div className="w-full max-w-sm bg-white rounded-2xl border border-slate-200 p-8">
        <Link to="/" className="flex items-center gap-2 text-lg font-bold text-slate-900 mb-8">
          <Globe className="w-5 h-5" />
          LCS International
        </Link>
        <h2 data-testid="forgot-heading" className="text-2xl font-bold text-slate-900 mb-2">
          Mot de passe oublié
        </h2>
        <p className="text-slate-500 mb-6 text-sm">
          Entrez votre adresse courriel pour recevoir un lien de réinitialisation.
        </p>

        {message && (
          <div data-testid="forgot-success" className="mb-4 text-sm text-green-700 bg-green-50 border border-green-200 rounded-lg px-4 py-3">
            {message}
          </div>
        )}
        {error && (
          <div data-testid="forgot-error" className="mb-4 text-sm text-red-700 bg-red-50 border border-red-200 rounded-lg px-4 py-3">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            data-testid="forgot-email-input"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full border border-slate-300 rounded-lg px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-slate-900 focus:border-transparent"
            placeholder="vous@exemple.com"
          />
          <button
            data-testid="forgot-submit-button"
            type="submit"
            disabled={submitting}
            className="w-full bg-slate-900 text-white font-medium rounded-lg px-4 py-3 hover:bg-slate-700 transition-colors duration-200 disabled:opacity-50"
          >
            {submitting ? "Envoi…" : "Envoyer le lien"}
          </button>
        </form>

        <p className="text-sm text-slate-500 mt-6 text-center">
          <Link to="/login" data-testid="forgot-login-link" className="font-medium text-slate-900 hover:underline">
            Retour à la connexion
          </Link>
        </p>
      </div>
    </div>
  );
}
